"use client";

import dynamic from "next/dynamic";

/**
 * Client-only wrapper around the real ResumeViewer implementation.
 *
 * `react-pdf` (pdfjs-dist) runs `new DOMMatrix()` at module-evaluation time,
 * and DOMMatrix is a browser-only global. Next.js evaluates `"use client"`
 * modules on the SERVER during SSR, so importing the implementation directly
 * would throw `ReferenceError: DOMMatrix is not defined` and 500 the route
 * (e.g. `/jobs/.../sequences/.../steps`, which transitively pulls the pipeline
 * profile via the `@/features/jobs` barrel). Loading it via
 * `dynamic(..., { ssr: false })` defers the pdf.js import to the browser.
 */
export const ResumeViewer = dynamic(
  () => import("./resume-viewer-impl").then((m) => m.ResumeViewer),
  { ssr: false },
);
